export default "__VITE_ASSET__BJ67QHNg__"